import * as React from "react";
import "./LevelChangeTop.css";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Select from "@mui/material/Select";
import { useStoreDollHouseMap } from "../store";
import { useTheme } from "@mui/material/styles";
import { shallow } from "zustand/shallow";
import $ from "jquery";
import { resetAllMapPathSvg } from "../components/customEvents.js";

export default function LevelChangeTopComponent({
  setBaseMapView,
  levelList,
  isLevelNeedToReset,
  changedLevel,
  levelmap,
}) {
  const theme = useTheme();
  const [level, setLevel] = React.useState("");
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      handleLevelChangeCosmo: state.handleLevelChangeCosmo,
      handleLevelChangeAria: state.handleLevelChangeAria,
      sourceAreaSelected: state.sourceAreaSelected,
      destinationAreaSelected: state.destinationAreaSelected,
      changePopupvisibility: state.changePopupvisibility,
      setSourceAreaSelected: state.setSourceAreaSelected,
      setDestinationAreaSelected: state.setDestinationAreaSelected,
      setRouteTypeSelected: state.setRouteTypeSelected,
    }),
    shallow
  );

  React.useEffect(() => {
    if (changedLevel) setLevel(changedLevel);
  }, [changedLevel]);

  const handleChange = (event) => {
    if (
      dollhouseStore.sourceAreaSelected !== "" &&
      dollhouseStore.destinationAreaSelected !== ""
    ) {
      // dollhouseStore.changePopupvisibility(
      //   true,
      //   "Please clear the selected route before proceeding to the level change."
      // );

      dollhouseStore.setSourceAreaSelected("");
      dollhouseStore.setDestinationAreaSelected("");
      dollhouseStore.setRouteTypeSelected("all");

      resetAllMapPathSvg();

      //return false;
    }

    if (levelmap === "cosmo") {
      dollhouseStore.handleLevelChangeCosmo(event.target.value);
    }

    if (levelmap === "aria") {
      dollhouseStore.handleLevelChangeAria(event.target.value);
    }
    setLevel(event.target.value);
    setBaseMapView(event.target.value);
    if (event.target.value === "area_level_1") {
    }
    if (event.target.value === "area_level_2") {
    }
  };

  React.useEffect(() => {
    if (isLevelNeedToReset) {
      if (levelmap === "cosmo") {
        setLevel(levelList[1].key);
      } else {
        setLevel(levelList[0].key);
      }
    }
  }, [isLevelNeedToReset]);

  React.useEffect(() => {
    if (levelList) {
      if (levelmap === "cosmo") {
        setLevel(levelList[1].key);
      } else {
        setLevel(levelList[0].key);
      }
    }
    $("#main-selectcosmo").css("border-radius", "unset");
    $("#main-selectaria").css("border-radius", "unset");
  }, [levelList]);

  React.useEffect(() => {
    $("fieldset").remove();
  }, []);

  return (
    <Box
      className="level-header"
      sx={{
        [theme.breakpoints.down("md")]: {
          background: "#000 0% 0% no-repeat padding-box !important",
        },
      }}
    >
      {levelList && (
        <Box sx={{ width: 80, mx: "auto" }}>
          <FormControl sx={{ width: 80 }} size="small">
            <Select
              className="dropdown-menu "
              value={level}
              onChange={handleChange}
              displayEmpty
              inputProps={{
                "aria-label": "Without label",
                disableUnderline: true,
              }}
              id={`main-select${levelmap}`}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "unset !important",
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                      {
                        border: 0,
                      },
                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        border: 0,
                      },
                    bgcolor: "rgba(0,0,0,0.9)",
                    "& .MuiMenuItem-root": {
                      px: 2,
                      paddingTop: "3px",
                      paddingBottom: "3px",
                    },
                    "& .MuiMenuItem-root:hover": {
                      backgroundColor: "transparent",
                      color: "#716548",
                    },
                    color: "white",
                    "& .Mui-selected": {
                      color: "#716548",
                    },
                    "& .MuiMenuItem-root": {},
                  },
                },
              }}
              sx={{
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                  // borderBottom: "1px solid #716548",
                  py: 0,
                  textAlign: "left",
                },
              }}
            >
              {levelList.map((val) => {
                return (
                  <MenuItem
                    value={val.key}
                    key={val.key}
                    sx={{
                      fontSize: "13px",
                      color: " #fffffff2",
                      fontFamily: "'Trade Gothic LT Std',sans-serif",
                      fontWeight: "normal",
                    }}
                  >
                    {val.title}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
}
